import styled from 'styled-components';
import { darken } from 'polished';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonSearchContainerProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: ReactNode;
};

export const Container = styled.button<ButtonSearchContainerProps>`
  height: 20px;
  width: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  :hover {
    background-color: ${darken(0.045, '#ffffff')};
  }

  svg {
    width: 24px;
  }
`;
